import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import request from '@/api/axios';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    user: null,
    seo: null,
    article: false,
  };
};

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: getDefaultState,
  actions: {
    onArticle({ commit }) {
      commit('article', true);
    },
    offArticle({ commit }) {
      commit('article', false);
    },
    onPost({ commit }) {
      commit('post', true);
    },
    offPost({ commit }) {
      commit('post', false);
    },
    async getUser({ commit }) {
      try {
        const fromStorage = localStorage.getItem('user');
        if (fromStorage) {
          commit('login', JSON.parse(fromStorage));
        }
        const response = (await request({ action: 'user' })).data;

        if (response && response.status === true) {
          if (response.user) {
            commit('login', response.user);
          }
        } else {
          commit('logout');
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getSeo({ commit }) {
      try {
        const response = (await request({ action: 'get_seo' })).data;
        if (response && response.seo) {
          commit('setSeo', response.seo);
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
  getters: {},
  mutations: {
    logout(state) {
      state.user = null;
    },
    article(state, payload) {
      state.article = payload;
    },
    post(state, payload) {
      state.post = payload;
    },
    login(state, user) {
      state.user = user;
      localStorage.setItem('user', JSON.stringify(user));
    },
    setSeo(state, seo) {
      state.seo = seo;
    },
  },
});
